import rewardsActions from './rewards.actions';
import groupRewardsActions from './group.rewards.actions';

export default {
  ...rewardsActions,
  ...groupRewardsActions
};
